/**
 * Admin 登录页
 * 替换旧的密码保护 LoginPage，对接 /auth/admin/login
 */
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import adminAuthService from '../../services/adminAuthService';
import '../../styles/LoginPage.css';

function AdminLoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/admin/model-trial';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await adminAuthService.login(username, password);
      navigate(from, { replace: true });
    } catch (err) {
      const msg = err.response?.data?.detail || '用户名或密码错误';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <h1>管理后台</h1>
          <p>请使用管理员账号登录</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="用户名"
              className="password-input"
              disabled={loading}
              autoFocus
            />
          </div>
          <div className="input-group">
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="密码"
              className="password-input"
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">⚠️ {error}</div>}

          <button
            type="submit"
            className="login-button"
            disabled={loading || !username || !password}
          >
            {loading ? '登录中...' : '登录'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default AdminLoginPage;
